// @flow

import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Select from '../formElements/select/select';
import {
  getClientSearchPlaceholder,
  minimumClientSearchCharacterLength
} from '../../../services/helpers';
import {
  getClientList,
  getIsFetchingClients,
  getClientSearchInput
} from './clientSearchRedux/clientSearchReducer';
import {
  setClientSearchInput,
  getClients
} from './clientSearchRedux/clientSearchActionCreator';

type Props = {
  clientSearchInput: string,
  isFetching: boolean,
  clientList: Array,
  setClientSearchInput: Function,
  onSelect?: Function,
  cnoteType?: string,
  isClientUser?: boolean,
  isServiceabilityClient?: boolean,
  showAllOption?: boolean,
  disableNone?: boolean,
  onClientFetchSucess?: Function,
  defaultClientSearchInput?: string,
  clientListFilter?: Function,
  getClients: Function,
  clientSearchWrapperClassName?: string,
  userProfile?: Object,
  disabled?: boolean
};

class ClientSearch extends React.Component<Props> {
  constructor(props) {
    super(props);
    this.clientListNameValStrings = { nameKey: 'clientCode', valKey: 'id' };
    this.fetchClientsTimeout = null;
    this.onClientSearch = this.onClientSearch.bind(this);
  }

  componentDidMount() {
    if (this.props.defaultClientSearchInput) {
      this.onClientSearch(this.props.defaultClientSearchInput);
    } else {
      this.getClients(this.props);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      !nextProps.clientSearchInput &&
      nextProps.defaultClientSearchInput !== this.props.defaultClientSearchInput
    ) {
      this.onClientSearch(nextProps.defaultClientSearchInput);
    }

    if (nextProps.cnoteType && nextProps.cnoteType !== this.props.cnoteType) {
      this.getClients(nextProps);
    }
  }

  onClientSearch(clientSearchInput) {
    this.props.setClientSearchInput(clientSearchInput);
    if (
      this.props.isClientUser ||
      !clientSearchInput ||
      clientSearchInput.length < minimumClientSearchCharacterLength
    ) {
      return;
    }
    if (this.fetchClientsTimeout !== null) {
      clearTimeout(this.fetchClientsTimeout);
    }
    this.fetchClientsTimeout = setTimeout(
      () => this.getClients(this.props),
      500
    );
  }

  getClients(props) {
    props.getClients(
      props.cnoteType,
      props.clientSearchInput,
      props.isClientUser || props.isServiceabilityClient,
      props.showAllOption,
      props.clientListFilter,
      props.onClientFetchSucess,
      props.userProfile,
      props.isEditPrq
    );
  }

  render() {
    const {
      clientSearchInput,
      isFetching,
      clientList,
      onSelect,
      disableNone,
      defaultClientSearchInput,
      isClientUser,
      isServiceabilityClient,
      clientSearchWrapperClassName,
      disabled,
      ...restProps
    } = this.props;
    return (
      <div className={clientSearchWrapperClassName}>
        <Select
          label={getClientSearchPlaceholder(
            clientSearchInput || defaultClientSearchInput,
            isFetching,
            clientList
          )}
          optionsArrOfObj={clientList}
          onSelect={onSelect}
          onSearchValueChange={this.onClientSearch}
          disableNone={disableNone}
          enableSearch={!isClientUser}
          disabled={disabled || (isClientUser && clientList.length < 2)}
          nameValStrings={this.clientListNameValStrings}
          {...restProps}
        />
      </div>
    );
  }
}

ClientSearch.defaultProps = {
  onSelect: (selectedNameKey, selectedObj) => {
    console.log('Selected value', selectedNameKey, selectedObj);
  },
  cnoteType: '',
  isClientUser: false,
  isServiceabilityClient: false,
  showAllOption: false,
  disableNone: false,
  onClientFetchSucess: fetchedClientList =>
    console.log('Clients fetched successfully', fetchedClientList),
  defaultClientSearchInput: '',
  clientSearchWrapperClassName: 'zt-filter-component-wrapper',
  disabled: false
};

const mapStateToProps = state => ({
  clientList: getClientList(state),
  isFetching: getIsFetchingClients(state),
  clientSearchInput: getClientSearchInput(state)
});

const mapDispatchToProps = dispatch => ({
  setClientSearchInput: bindActionCreators(setClientSearchInput, dispatch),
  getClients: bindActionCreators(getClients, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ClientSearch);
